import DebouncedResize from '../helpers/DebouncedResize';

export default class Navigation {
    constructor(root) {
        this.root = root;
        this.meganav_container = this.root.querySelector('.js-meganav');
        this.meganav_items = this.root.querySelectorAll('.js-meganav-item');
        this.subnav_items = this.root.querySelectorAll('.js-subnav-item');
        this.mobile_nav_button = this.root.querySelector('.js-mobile-nav-button');

        this.onClick = (event) => {
            if(event.target.classList.contains('--has-children')) {
                event.preventDefault();
            }

            this.meganav_items.forEach((meganav_item) => {
                meganav_item.classList.remove('--open');
            });

            if(this.opened_subnav == event.target.dataset.subnav) {
                this.closeAllSubnavs();
            } else {
                event.target.classList.add('--open');
                this.openSubnav(event.target.dataset.subnav);
            }
        }

        this.onMouseenter = (event) => {
            this.openSubnav(event.target.dataset.subnav);
        }

        this.onMouseleave = (event) => {
            this.closeAllSubnavs();
        }

        this.mobile_nav_button.addEventListener('click', (event) => {
            event.preventDefault();
            this.mobile_nav_button.classList.toggle('--active');
            this.meganav_container.classList.toggle('--active');
        });

        new DebouncedResize(() => {
            this.clearEventListeners();

            if(document.body.clientWidth <= 1015) {
                //use mobile logic
                this.meganav_items.forEach((meganav_item) => {
                    meganav_item.addEventListener('click', this.onClick);
                });
            } else {
                //use desktop logic
                this.meganav_items.forEach((meganav_item) => {
                    meganav_item.addEventListener('mouseenter', this.onMouseenter);
                });

                this.root.addEventListener('mouseleave', this.onMouseleave);
            }

            if(!this.was_scrolled) {
                this.root.classList.remove('--scrolled');
            }
        }, () => {
            if(this.root.classList.contains('--scrolled')) {
                this.was_scrolled = true;
            } else {
                this.was_scrolled = false;
                this.root.classList.add('--scrolled');
            }
        }, true);

        this.last_scrolltop = window.scrollY;

        document.addEventListener('scroll', () => { this.scrolling(window.scrollY) });

        //show correct nav on page load
        this.scrolling(window.scrollY, true);
    }

    clearEventListeners() {
        this.meganav_items.forEach((meganav_item) => {
            meganav_item.removeEventListener('mouseenter', this.onMouseenter);
            meganav_item.removeEventListener('click', this.onClick);
        });

        this.root.removeEventListener('mouseleave', this.onMouseleave);
    }

    openSubnav(subnav_id) {
        this.closeAllSubnavs();

        this.subnav_items.forEach((subnav) => {
            if(subnav.dataset.name == subnav_id) {
                this.opened_subnav = subnav_id;
                subnav.classList.add('--active');
                subnav.style.zIndex = '-1';
            }
        });
    }

    closeAllSubnavs() {
        this.opened_subnav = null;
        this.subnav_items.forEach((subnav) => {
            subnav.classList.remove('--active');
            subnav.style.zIndex = '-2';
        });
    }

    scrolling(position, initial_load = false) {
        if(!initial_load) {
            if(this.last_scrolltop > position) {
                //scrolling up
                this.root.classList.remove('--scrolled');
                this.root.parentElement.style.pointerEvents = 'all';
            } else {
                //scrolling down
                if(position > 120 && !this.meganav_container.classList.contains('--active')) {
                    this.root.classList.add('--scrolled');
                    this.root.parentElement.style.pointerEvents = 'none';
                } else {
                    this.root.classList.remove('--scrolled');
                    this.root.parentElement.style.pointerEvents = 'all';
                }
            }
        }

        this.last_scrolltop = window.scrollY;
    }
}
